export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
            <div className="flex-1">
              <div className="relative">
                <div className="absolute -inset-3 bg-gradient-to-br from-primary-100/50 to-accent-100/30 rounded-xl blur-xl"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20room%20with%20warm%20golden%20ambient%20lighting%2C%20large%20projection%20screen%20showing%20abstract%20film%20art%2C%20comfortable%20sofa%2C%20wooden%20side%20table%20with%20popcorn%20bowl%2C%20soft%20warm%20atmosphere%2C%20cinematic%20interior%20design&width=600&height=400&seq=about-cinema&orientation=landscape"
                  alt="蓝莓影院 · 关于我们"
                  className="relative rounded-xl w-full h-auto object-cover"
                  loading="lazy"
                  width="600"
                  height="400"
                  title="蓝莓影院 · 关于我们"
                />
              </div>
            </div>

            <div className="flex-1">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
                关于我们
              </span>
              <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading mb-4">
                蓝莓影院 · 你的私人影院
              </h2>
              <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  蓝莓影院诞生于对电影的热爱。我们是一个由资深影迷和技术极客共同打造的免费在线观影平台，
                  致力于为每一位热爱电影的人提供最纯粹、最流畅的观影体验。
                </p>
                <p>
                  平台片库涵盖动作、科幻、喜剧、悬疑、动画、纪录等全类型影片，覆盖全球六十余个国家和地区的电影作品。
                  无论是好莱坞商业巨制、欧洲艺术电影、日韩独立制作，还是华语新势力佳作，你都能在这里找到。
                </p>
                <p>
                  我们相信，好电影应该被更多人看到。蓝莓影院通过先进的内容分发技术和智能推荐算法，
                  打破地域和设备的限制，让高清流畅观影变得触手可及。每日更新的片库和不断优化的播放体验，
                  是我们对每一位影迷的承诺。
                </p>
              </div>

              <div className="flex flex-wrap gap-4 mt-6">
                {['免费观影', '高清画质', '极速加载', '每日更新', '海量片库'].map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1.5 rounded-lg bg-background-200/70 text-foreground-600 text-xs font-medium"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}